import React from "react";

/* eslint-disable max-len */
export default function VireCountIcon() {
    return (
        <svg version="1.1" id="icon" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
			viewBox="0 0 12.2 14.7" enableBackground="new 0 0 12.2 14.7" xmlSpace="preserve">
		<path fill="none" stroke="#7F7F7F" strokeMiterlimit="10" d="M11.1,6.5L2.2,0.8C1.5,0.4,0.7,0.9,0.7,1.6V13c0,0.8,0.9,1.3,1.5,0.8
			l8.9-5.7C11.7,7.8,11.7,6.9,11.1,6.5z"/>
		</svg>
    );
}
